export default "__VITE_ASSET__DCjCrOuZ__"